import { render, staticRenderFns } from "./WodeLayout.vue?vue&type=template&id=79e98dc8"
import script from "./WodeLayout.vue?vue&type=script&lang=js"
export * from "./WodeLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports